import { TFinanceData } from '../state/CompanyFundingsState';

/**
 * Calculates cumulative investment for each funding round.
 *
 * @param fundings - Array of funding data sorted by date ascending
 */
export function calculateFundingMetrics(fundings: TFinanceData[]): TFinanceData[] {
  let cumulativeInvestment = 0;

  return fundings.map((funding) => {
    const currentInvestment = funding.investmentAmount ?? 0;
    cumulativeInvestment += currentInvestment;

    return {
      ...funding,
      cumulativeInvestment,
    };
  });
}
